"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledExpandableContent = exports.StyledExpandableContentWrapper = void 0;
const ui_1 = require("@phishtool/ui");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledExpandableContentWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledExpandableContentWrapper", componentId: "sc-9uab4t" }) `
  border-radius: ${(props) => props.theme.radii.primary};
  box-shadow: 0 0 0 1px ${(props) => props.theme.colors.heroOrange},
    0 5px 40px 0 ${(props) => (0, ui_1.hexToRgba)(props.theme.colors.darkEclipse, 0.2)};
  padding: ${(props) => props.theme.spacers.x3};
  cursor: pointer;
`;
exports.StyledExpandableContent = styled_components_1.default.div.withConfig({ displayName: "StyledExpandableContent", componentId: "sc-f8g1qf" }) `
  height: 0;
  overflow: hidden;
  transition: height 0.25s ease-in-out;
`;
